import { render, staticRenderFns } from "./RewardCard.vue?vue&type=template&id=6e4eff1c"
import script from "./RewardCard.vue?vue&type=script&lang=js"
export * from "./RewardCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports